import { render, staticRenderFns } from "./ProjectLaboratoryRelationList.vue?vue&type=template&id=3c318565&scoped=true"
import script from "./ProjectLaboratoryRelationList.vue?vue&type=script&lang=js"
export * from "./ProjectLaboratoryRelationList.vue?vue&type=script&lang=js"
import style0 from "./ProjectLaboratoryRelationList.vue?vue&type=style&index=0&id=3c318565&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c318565",
  null
  
)

export default component.exports